import { Card, Group, Text } from "@mantine/core";
import { IconClock, IconLicense } from "@tabler/icons-react";

import OverviewFilterCaption from "../common/OverviewFilterCaption";
import OverviewStat from "../common/OverviewStat";

interface LicenseOverviewCounts {
	total: number;
	active: number;
	inactive: number;
	expired: number;
	held: number;
}

interface LicenseOverviewProps extends LicenseOverviewCounts {
	// Counts under the page's filters, shown under each total; null unfiltered
	filtered?: LicenseOverviewCounts | null;
	filterLabel?: string | null;
}

function LicenseOverview({
	total,
	active,
	inactive,
	expired,
	held,
	filtered,
	filterLabel,
}: LicenseOverviewProps) {
	return (
		<Card
			shadow="sm"
			padding="lg"
			radius="md"
			withBorder
			mb="lg">
			<Group
				justify="space-between"
				mb="md">
				<Group>
					<IconLicense size={20} />
					<Text fw={500}>License Overview</Text>
				</Group>
				<OverviewFilterCaption label={filtered ? (filterLabel ?? null) : null} />
			</Group>
			<Group>
				<OverviewStat
					value={total}
					label="Total Licenses"
					filteredValue={filtered?.total}
				/>
				<OverviewStat
					value={active}
					label="Active"
					color="green"
					filteredValue={filtered?.active}
				/>
				<OverviewStat
					value={inactive}
					label="Inactive"
					color="gray"
					filteredValue={filtered?.inactive}
				/>
				<OverviewStat
					value={expired}
					label="Expired"
					color="red"
					filteredValue={filtered?.expired}
				/>
				<OverviewStat
					value={held}
					label="On Hold"
					color="yellow"
					icon={
						<IconClock
							size={16}
							color="var(--mantine-color-yellow-6)"
						/>
					}
					filteredValue={filtered?.held}
				/>
			</Group>
		</Card>
	);
}

export default LicenseOverview;
